import { Component, Input, Output, EventEmitter, SimpleChanges, SimpleChange } from '@angular/core';
import { DevelopUtil } from '../../../utils/develop.utils';
import { environment } from '../../../../environments/environment';

@Component({
  moduleId: module.id,
  templateUrl: 'attachment.component.html',
  selector: 'bft-attachment',
  providers: []
})

export class AttachmentComponent {

  @Input()
  isAttached;

  @Input()
  dataSize;

  @Input()
  htmlId;

  @Output()
  triggerSetAttachment = new EventEmitter<any>();

  model: any = {};
  documentInfo;

  constructor() {
  }

  ngOnInit() {
  } 


  setAttachment($event) {
    $event.preventDefault();

    let fileList: FileList = $event.target.files;
    if (fileList) {

      var hash = environment.attachments.extensions;
      var re = /\..+$/;
      // var ext = fileList[0].name.match(re);
      let ext = fileList.item(0).name.split('.').pop();
      if (hash.indexOf( ext.toLowerCase() ) != -1 ) {
              
          this.triggerSetAttachment.next({attachment: fileList.item(0)});
          this.documentInfo = this.getDocumentInfo(fileList.item(0), $event);
        } else {
          alert("Выбранный тип файла запрещен");
          this.resetAttachment($event)
        }
          
    }
  }

  resetAttachment($event) {
    $event.preventDefault();
    this.triggerSetAttachment.next({attachment: ''});
  }

  getDocumentInfo(data: File, el) {
    let dataInfo: any = {};
    dataInfo.name = data.name;
    dataInfo.size = this.convertSize(data.size, el);
    return dataInfo;
  }

  convertSize(sizeByte, el) {
    let size: string;
    let kb = 1024;
    let mb = 1048576;
    let maxSize = environment.attachments.fileSize;

    if(sizeByte > +maxSize){
      alert('Размер файла не должен превышать ' + (+maxSize / kb) +' KB');
      this.resetAttachment(el);
    }
    else{

      if(sizeByte < mb) {
        size = Math.round(sizeByte / kb) + ' KB';
      } else {
        size = Math.round((sizeByte / mb) * 100) / 100 + ' MB';
      }
      return size;

    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/common/attachment/attachment.component.ts